module.exports = __webpack_public_path__ + "static/img/name1.adafdeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/th/name1.png
// module id = xAXu
// module chunks = 1